export interface AskPodTrialEndedPopupInterface {
    title?: string;
    message?: string;
}

/** A single paid package row rendered in the "Trial Has Ended" modal. */
export interface AskPodTrialEndedPackage {
    name: string;
    addonCode: string;
    dailyCredits: number;
    price: number | null;
    isBestValue: boolean;
}

export class AskPodTrialEndedPopupModel {
    title: string;
    message: string;

    constructor(model: AskPodTrialEndedPopupInterface) {
        this.title = model.title || 'askPodPopup.trialEndedTitle';
        this.message = model.message || 'askPodPopup.trialEndedMessage';
    }
}
